<template lang="pug">
.confirm-cards
  .left
    product-slot(:product="product")
  .right
    quantity-fixed(:amount="product.amount")

</template>
<script>
import ProductSlot from '@/components/futureshop/ProductSlot'
import QuantityFixed from '@/components/futureshop/QuantityFixed'
export default {
  name: 'ConfirmCard',
  components: { QuantityFixed, ProductSlot },
  props: {
    product: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.confirm-cards
  width: 940px
  margin: 0 auto
  height: 270px
  overflow: hidden
  border-radius: 18px
  background: #ffffff
  box-shadow: 0 -1px 10px 0 rgba(226,226,226,0.73)
  display: flex
  flex-direction: row
  align-items: center
  justify-content: space-between
  padding: 0 60px
</style>
